global.antRouter = ''//全局的路由
global.imgServer='http://site.api.lantogis.com/'   //http://182.92.60.122:9080/用于缩略图 和 文章内容图片的换src/views/layout/components/public.mixin.js  
// global.imgPath= global.imgServer+'sys/common/static/'//文章缩略图存放位置
global.imgPath=''




// WEBPACK FOOTER //
// ./src/utils/global.js